module.exports = __webpack_public_path__ + "static/media/about-ewer.314534c6.png";